module.exports = __webpack_public_path__ + "img/ppt.e8f28ab5.svg";